// extracted by mini-css-extract-plugin
module.exports = {"dateRangeCount":"ob_8Gs4cV","totalPref":"ob_JiNjE3"};